import { APP_INITIALIZER } from '@angular/core';
import { ReCaptchaConfigService } from '../service/recaptcha-config.service';
import { ReCaptchaConfigArgs } from '../type/recaptcha.type';

export function getInitRecaptchaConfigProvider(args: ReCaptchaConfigArgs) {
  return {
    provide: APP_INITIALIZER,
    useFactory: (service: ReCaptchaConfigService) => () => service.loadConfig(args),
    deps: [ReCaptchaConfigService],
    multi: true,
  };
}
